





import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    name: "EnumLabel"
})
export default class extends Vue {
    @Prop({ required: true })
    readonly enumNamed!: string;
    @Prop({ required: true })
    readonly enumKey!: string;

    get tranPrefix() {
        return this.enumNamed ? `${this.enumNamed}.` : "";
    }
}
